import { I18nContext } from 'contexts/I18n/I18nProvider';
import NoRecords from 'core/no-records/no-records-container';
import { useCallback, useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import HouseHold from './components/Household';
import RecordingsContainer from './components/npvr/RecordingsContainer';
import { NpvrFilterAndPagination } from './redux/actions';
import { NpvrState } from './redux/types';

type NpvrProps = {
  npvr: NpvrState
  fetch: (hhid: string, filter?: NpvrFilterAndPagination) => void
  clearAccordionTable: (id: string) => void
  clearCachedNpvr: () => void
  getAssociatedDevices: (hhid: string) => void
}

export type OnGetHouseHoldCallback = (hhid: string) => void

export default function Npvr({ npvr, fetch, clearAccordionTable, clearCachedNpvr, getAssociatedDevices }: NpvrProps) {
  const t = useContext(I18nContext)
  const params = useParams()
  const navigate = useNavigate()
  const { hhid } = params

  useEffect(() => {
    if(hhid){
      fetch(hhid, {})
      getAssociatedDevices(hhid)
    } 

    return () => {
      clearCachedNpvr()
      clearAccordionTable('accordion.dvr')
    }
  }, [hhid])


  const onGetHouseHold = useCallback((hhid: string) => {
    navigate(`/operational/npvr/${hhid}`)
  }, [])

  return (
    <div style={{marginTop: '.5rem'}}>
      <HouseHold onGetHouseHold={onGetHouseHold} hhIdQuery={hhid}/>
      <div>
      {npvr.householdDevicesItems.devices.length ?
        <RecordingsContainer hhid={hhid}/> :
        <NoRecords subtitle={t('npvr.search_household')}/>}
      </div>
    </div>
  )
}
